"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OPTION = '[data-ref~="option"]';